// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeController_inputRoot__35KSv","arrowIcon":"DateRangeController_arrowIcon__2EM2e"};